/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

/*
 * Get Registered accounts Snippet of HTML
 */
var accountTemplate = require('../../templates').accountTemplate;
var accountDeleteTemplate = require('../../templates').accountDeleteTemplate;
var translate = require('./translate.service');
var maskedAccountService = require('./masked-account.service');
var rootScope = require('./root-scope.service');
var _ = require('underscore');

function createAnAccount(account, showDelete, templateName, isCardView = false) {
    account.isSingle = rootScope.getIsSingleMethod();
    account.isCardView = isCardView;

    return showDelete ? accountDeleteTemplate(account, templateName) : accountTemplate(account, templateName);
}

function createAccountList(accounts, showDelete, templateName) {
    const isCardView = rootScope.isCardView() == 'true' ? true : false;
    var accountsList = '';
    var index = 0;
    _.each(accounts, function (account) {
        account.networkCode = 'registered' + account.code + index;
        account.grouping = 'grouping' + account.networkCode;
        account.id = index;
        account.tooltip = translate('accounts.delete.tooltip.label');
        index++;

        // Normalize a display label: spaces to non-breakable spaces
        if (account.maskedAccount && account.maskedAccount.displayLabel) {
            account.maskedAccount.displayLabel = maskedAccountService.formatMaskedAccount(account);
        }
        if (account.maskedAccount && account.maskedAccount.expiryMonth && account.maskedAccount.expiryYear) {
            account.dateString = maskedAccountService.formatDateString(account);
        }

        account.expiredLabel = translate('accounts.expired.badge.label');
        account.isExpired = maskedAccountService.isExpired(account);

        accountsList += createAnAccount(account, showDelete, templateName, isCardView);
    });

    return accountsList;
}

/**
 * Return registered accounts.
 *
 * @param accounts {Array} The registered accounts
 * @param showDelete {Boolean}
 * @param templateName {String}
 * @return snippet {String} snippet of HTML containing the list of registered accounts
 */
function getRegisteredAccount(accounts, showDelete, templateName) {
    if (!accounts.length) {
        return '';
    }

    return createAccountList(accounts, showDelete, templateName);
}

module.exports = getRegisteredAccount;
